<template>
  <div class="topbar">
    <div class="keyword-container">
      <div class="search-column">
        <form class="keyword-filter" @submit.prevent>
          <label class="keyword-filter__wrapper">
            <input
              type="text"
              class="keyword-filter__input"
              autocomplete="off"
              :placeholder="$t('kiosk.title')"
              v-model.trim="keyword"
              @input="onSearch"
            />
          </label>
        </form>
        <div class="type-filter">
          <label class="type-filter__option">
            <input type="checkbox" class="type-filter__checkbox" v-model="showGuestParking" @change="onFilter">
            <span class="type-filter__custom-checkbox"></span>
            <span class="type-filter__label">Guest parking kiosk</span>
          </label>
          <label class="type-filter__option">
            <input type="checkbox" class="type-filter__checkbox" v-model="showFranky" @change="onFilter">
            <span class="type-filter__custom-checkbox"></span>
            <span class="type-filter__label">Franky</span>
          </label>
        </div>
      </div>
    </div>
    <div class="topbar__cell">
      <div class="buttonset">
        <router-link class="buttonset__button btn btn--main" :to="{ name: 'add-kiosk' }">
          {{ $t('kiosk.add_kiosk') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _debounce from 'lodash/debounce';
import 'styles/blocks/keyword-filter.scss';

export default {
  data() {
    const queryType = this.$route.query.kiosk_type;
    return {
      keyword: this.$route.query.keyword || '',
      showGuestParking: queryType !== 'franky',
      showFranky: queryType !== 'guest_parking_kiosk',
    };
  },
  computed: {
    ...mapGetters({
      user: 'user/user/user',
    }),
    kioskType() {
      if (this.showGuestParking && !this.showFranky) {
        return 'guest_parking_kiosk';
      }
      if (this.showFranky && !this.showGuestParking) {
        return 'franky';
      }
      return null;
    },
  },
  methods: {
    onSearch: _debounce(function () {
      this.applyFilters();
    }, 600),
    onFilter() {
      this.applyFilters();
    },
    applyFilters() {
      this.$store.dispatch('kiosks/kiosks/fetch', { keyword: this.keyword, kioskType: this.kioskType, user: this.user });
      const query = {};
      if (this.keyword) query.keyword = this.keyword;
      if (this.kioskType) query.kiosk_type = this.kioskType;
      this.$router.push({ query });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-column {
  display: flex;
  flex-direction: column;
  max-width: 470px;
  width: 100%;

  .keyword-filter {
    max-width: none;
    width: 100%;
  }
}

.type-filter {
  display: flex;
  gap: 30px;

  &__option {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__checkbox {
    display: none;
  }

  &__custom-checkbox {
    width: 32px;
    height: 34px;
    margin: 10px 15px 10px 0;
    border: solid 1px var(--grey-five);
    flex-shrink: 0;
  }

  &__checkbox:checked + .type-filter__custom-checkbox {
    position: relative;

    &:after {
      content: ' ';
      position: absolute;
      top: 4px;
      left: 10px;
      width: 8px;
      height: 16px;
      transform: rotate(45deg);
      border: solid var(--brand-blue);
      border-width: 0 2px 2px 0;
      animation: checkBoxIn 245ms ease-in-out;
    }
  }

  &__label {
    color: var(--black);
    line-height: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/kiosks/Topbar.vue